export default {"src":"/_next/static/media/assumptions2.11998f11.svg","height":440,"width":640};